
export const getApps = store => store.apps;
export const getClients = store => store.clients;
export const getServices = store => store.services;
export const getProviders = store => store.providers;
export const getStatuses = store => store.statuses;
export const getAuth = store => store.auth;
